// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Main_pageContent_EZ4zR"};